@let ctaFormValue = ctaFormGroup();
@let platformFeature = selectedPlatformFeature();

@if (ctaFormValue && platformFeature) {
  <div class="flex flex-col gap-14 custom-form" [formGroup]="ctaFormValue">
    <div class="flex flex-col gap-6">
      <div class="flex flex-col">
        <h3 class="text-2xl">
          {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.reviewStep.title' | translate }}
        </h3>

        <p class="text-shikenso-purple-base-60">
          {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.reviewStep.description' | translate }}
        </p>
      </div>

      <div class="flex flex-wrap items-center gap-3">
        <div
          class="flex min-h-12 min-w-12 items-center justify-center rounded-full border border-shikenso-pink-base p-3"
          matTooltipPosition="above"
          [matTooltip]="'shared.platformFeatures.' + platformFeature | translate"
        >
          <app-social-badge
            backgroundColor="transparent"
            [borderRadius]="999"
            [iconSize]="16"
            [size]="16"
            [type]="platformFeature"
          />
        </div>

        <div class="flex min-h-12 items-center gap-2 rounded-full border border-shikenso-pink-base p-3">
          <app-icon src="icons/clipboard-list.svg" alt="Deliverables" [size]="16" />
          <span> {{ deliverableCount() }} {{ deliverableLabelTranslationKey() | translate }} </span>
        </div>

        <div class="flex min-h-12 items-center gap-2 rounded-full border border-shikenso-pink-base p-3">
          <app-icon src="icons/calendar-event.svg" alt="Executions" [size]="16" />
          <span>{{ executionCount() }}x</span>
        </div>

        <div class="flex min-h-12 items-center gap-2 rounded-full border border-shikenso-pink-base p-3">
          <app-icon src="icons/chart-histogram.svg" alt="KPIs" [size]="16" />
          <span> {{ kpiCount() }} {{ kpiLabelTranslationKey() | translate }} </span>
        </div>
      </div>
    </div>

    <div class="flex w-full flex-col gap-2">
      <span class="text-xl">
        {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.reviewStep.groupNameLabel' | translate }}
      </span>

      <mat-form-field class="w-full">
        <mat-label>
          {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.reviewStep.namePlaceholder' | translate }}
        </mat-label>
        <input matInput formControlName="name" />
        <mat-error [control]="ctaFormValue.get('name')" />
      </mat-form-field>
    </div>
  </div>
}
